import React from "react";
import withLayout from "../../../components/desktop/layout/component";
import ErrorHandler from "../../../components/shared/with-error-handler";
import ScrapCars from "../../../components/desktop/scrap-cars";
import withReducer from "../../../components/shared/with-reducer";
import injectable from "./injectable";

const ScrapCarsContainer = () => {
    return (
        <ErrorHandler>
            <ScrapCars />
        </ErrorHandler>
    );
};

export default withReducer(injectable)(() => ({}), dispatch => ({dispatch}))(
    withLayout(
        ScrapCarsContainer,
        true,
        true,
        true,
        false
    )
);
